import { BulkUploadActionType, UploadStatus } from '../../enum';
import {
  BulkUploadActions,
  BulkUploadState,
  QueuedUpload,
  RejectedUpload,
  UploadingUpload,
  UploadType,
} from '../../models';

export const bulkUploadReducer = (
  prevState: BulkUploadState,
  action: BulkUploadActions
) => {
  switch (action.type) {
    case BulkUploadActionType.ADD_UPLOADS:
      return {
        ...prevState,
        queued: [...prevState.queued, ...action.payload.queued],
        rejected: [...prevState.rejected, ...action.payload.rejected],
        totalCount:
          prevState.totalCount +
          action.payload.queued.length +
          action.payload.rejected.length,
      };
    case BulkUploadActionType.REMOVE_UPLOAD: {
      const collection: UploadType[] = prevState[action.payload.collection];
      const filteredCollection = collection.filter(
        (upload) => upload.id !== action.payload.id
      );
      return {
        ...prevState,
        [action.payload.collection]: filteredCollection,
        totalCount:
          prevState.totalCount -
          (collection.length - filteredCollection.length),
      };
    }
    case BulkUploadActionType.REMOVE_QUEUED_UPLOADS:
      return {
        ...prevState,
        queued: [],
        totalCount: prevState.totalCount - prevState.queued.length,
      };
    case BulkUploadActionType.MOVE_QUEUED_TO_UPLOADING: {
      const queuedUpload = prevState.queued.find(
        (upload) => upload.id === action.payload.id
      );
      if (!queuedUpload) {
        return prevState;
      }
      const uploadingUpload: UploadingUpload = {
        ...queuedUpload,
        status: UploadStatus.UPLOADING,
      };
      return {
        ...prevState,
        queued: prevState.queued.filter(
          (upload) => upload.id !== action.payload.id
        ),
        uploading: [...prevState.uploading, uploadingUpload],
      };
    }
    case BulkUploadActionType.MOVE_UPLOADING_TO_REJECTED: {
      const uploadingUpload = prevState.uploading.find(
        (upload) => upload.id === action.payload.id
      );
      if (!uploadingUpload) {
        return prevState;
      }
      const rejectedUpload: RejectedUpload = {
        ...uploadingUpload,
        status: UploadStatus.REJECTED,
        error: action.payload.error,
      };
      return {
        ...prevState,
        uploading: prevState.uploading.filter(
          (upload) => upload.id !== action.payload.id
        ),
        rejected: [...prevState.rejected, rejectedUpload],
      };
    }
    case BulkUploadActionType.MOVE_REJECTED_TO_QUEUED: {
      const rejectedUpload = prevState.rejected.find(
        (upload) => upload.id === action.payload.id
      );
      if (!rejectedUpload) {
        return prevState;
      }
      const { error, ...restUpload } = rejectedUpload;
      const queuedUpload: QueuedUpload = {
        ...restUpload,
        status: UploadStatus.QUEUED,
      };
      return {
        ...prevState,
        queued: [queuedUpload, ...prevState.queued],
        rejected: prevState.rejected.filter(
          (upload) => upload.id !== action.payload.id
        ),
      };
    }
  }
};
